import { GetBlacklistResponse } from "@1games-ru/region-shared/dist/backend/requests/faction";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import FactionMpProvider from "@/core/data-provider/data-mp/faction/faction-mp-provider";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { ColleaguesTabsEnum } from "@/domains/faction/constants/colleaguesTabsEnum";
import toast from "@/domains/toasts/helpers/toast";

export const QUERY_KEY_FACTION_BLACK_LIST = "QUERY_KEY_FACTION_BLACK_LIST";

export default function useGetBlackList(activeTab: ColleaguesTabsEnum) {
  const { t, i18n } = useTranslation("faction");

  const query = useQuery<GetBlacklistResponse>({
    queryKey: [QUERY_KEY_FACTION_BLACK_LIST],
    enabled: activeTab === ColleaguesTabsEnum.BLACKLIST,
    retry: false,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const response = await FactionMpProvider.getBlacklist();

      if (response instanceof RpcMpProviderSuccessResponse) {
        return response.data;
      }

      const messageKey = response?.error?.message ?? "Unknown";
      const knownI18nKey = i18n.exists(`faction:faction.errors.${messageKey}`);

      const error = new Error(messageKey) as Error & { knownI18nKey?: boolean };
      error.knownI18nKey = knownI18nKey;
      throw error;
    },
  });

  useEffect(() => {
    if (!query.isError) return;
    const error = query.error as Error & { knownI18nKey?: boolean };
    console.log(error);

    if (error.knownI18nKey) {
      toast.error(t(`faction.errors.${error.message}`));
    } else {
      toast.error(t("faction.toast.tableLoadError"));
    }
  }, [query.isError, query.error, t]);

  return {
    isBlackListLoading: query.isPending || query.isFetching,
    blackListData: query.data ?? null,
    blackListRefetch: query.refetch,
  };
}
